/* tslint:disable */

declare var Object: any;
export interface ResiduePartnerKpiTypeInterface {
  "id"?: number;
  "name"?: string;
  "description"?: string;
}

export class ResiduePartnerKpiType implements ResiduePartnerKpiTypeInterface {
  "id": number;
  "name": string;
  "description": string;
  constructor(data?: ResiduePartnerKpiTypeInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ResiduePartnerKpiType`.
   */
  public static getModelName() {
    return "ResiduePartnerKpiType";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ResiduePartnerKpiType for dynamic purposes.
  **/
  public static factory(data: ResiduePartnerKpiTypeInterface): ResiduePartnerKpiType{
    return new ResiduePartnerKpiType(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ResiduePartnerKpiType',
      plural: 'ResiduePartnerKpiTypes',
      path: 'ResiduePartnerKpiTypes',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ResiduePartnerKpiType.ts